import React from 'react';
const testimonials = [{
  text: 'Lavoro in un centro fitness con quattro gruppi senior a settimana e passavo ogni domenica a preparare le schede. Con la Complete Session Library apro il sistema, scelgo la sessione da 45 minuti e in dieci minuti ho tutto pronto. Ho recuperato il mio weekend e i miei clienti trovano le lezioni molto più curate.',
  author: 'Marco Rinaldi',
  role: 'Personal Trainer specializzato fitness senior, 48 anni',
  location: 'Bologna, Italia'
}, {
  text: "Il modulo di adattamento è quello che uso di più: nei miei gruppi ho signore di 65 anni molto attive e altre con protesi d'anca. Adesso ho regressioni e progressioni già pronte per ogni esercizio e non devo più improvvisare davanti alla classe.",
  author: 'Giulia Ferraro',
  role: 'Istruttrice di ginnastica dolce, 41 anni',
  location: 'Torino, Italia'
}, {
  text: 'Sono un chinesiologo e seguo attività motoria per over 65 in due associazioni sportive. Le schede di valutazione funzionale mi hanno permesso di mostrare i progressi reali ai clienti e ai loro familiari: la fidelizzazione è aumentata tantissimo.',
  author: 'Alessandro Bianchi',
  role: 'Chinesiologo e Coach Attività Motoria, 52 anni',
  location: 'Verona, Italia'
}, {
  text: 'Avevo cartelle piene di PDF, appunti dei corsi e video salvati, ma nessun ordine. Ora ho un unico sistema professionale: programmi di 12 settimane già impostati e planner annuale. Preparo il trimestre in una sola sera.',
  author: 'Silvia Moretti',
  role: 'Titolare di studio fitness per adulti senior, 45 anni',
  location: 'Firenze, Italia'
}, {
  text: 'Ho iniziato da poco a lavorare con i senior e avevo paura di sbagliare con l\'equilibrio e la prevenzione delle cadute. Il bonus dedicato mi ha dato protocolli chiari e sicuri: le mie lezioni sono piene e i partecipanti si muovono con più fiducia.',
  author: 'Davide Colombo',
  role: 'Istruttore di Sala e Coach di Gruppo, 34 anni',
  location: 'Milano, Italia'
}];
export function Testimonials() {
  return <section className="py-8 px-4 sm:px-6 bg-white" data-id="element-132" data-mp="1siweikqe608u">
      <h2 className="text-xl sm:text-3xl font-heading font-extrabold text-center text-petrol leading-tight uppercase mb-5" data-id="element-133" data-mp="1sk7fydwd6vws">
        Cosa Dicono gli Allenatori
      </h2>

      <div className="flex flex-col gap-3 max-w-3xl mx-auto" data-id="element-134" data-mp="1jj0z23pszj30">
        {testimonials.map(t => <div key={t.author} className="bg-cream border border-gold/30 p-4 rounded-lg" data-id="element-135" data-mp="1ejelft62c0to">
            <p className="text-gold text-xs tracking-tighter mb-1.5" aria-label="5 su 5" data-id="element-136" data-mp="19rmwfn2k235n">
              ⭐⭐⭐⭐⭐
            </p>
            <p className="text-warmgray text-[13px] sm:text-sm leading-relaxed italic mb-3" data-id="element-137" data-mp="14r8wytf0s1j8">
              "{t.text}"
            </p>
            <div className="flex items-center gap-3 border-t border-gold/20 pt-2.5" data-id="element-138" data-mp="vt6nrql4u2kv">
              <div className="w-9 h-9 rounded-full bg-petrol/10 border border-petrol/20 flex items-center justify-center text-petrol font-heading font-bold shrink-0" data-id="element-139" data-mp="qtk8lblquc9f">
                {t.author.charAt(0)}
              </div>
              <div className="leading-tight" data-id="element-140" data-mp="37f7hgzzu14ze">
                <p className="font-heading font-bold text-petrol text-[13px] sm:text-sm" data-id="element-141" data-mp="37i3f0n7rprnb">
                  {t.author}
                </p>
                <p className="text-[11px] text-warmgray" data-id="element-142" data-mp="3gh6yvtereb2v">
                  {t.role} — {t.location}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}